import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentPage,
  setPageSize,
} from "../../../redux/giftExchange/giftExchange";
import { Link, useNavigate } from "react-router-dom";
import {
  PlusCircleOutlined,
  ShopOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import {
  Empty,
  Table,
  Form,
  message,
  Tooltip,
  Popconfirm,
  TreeSelect,
  Select,
  Space,
  DatePicker,
  Typography,
  Badge,
  Card,
} from "antd";
import {
  deleteGiftExchange,
  getListGiftExchange,
  statusGiftExchange,
} from "../../../api/giftExchange/giftExchange";
// import { store } from "../../../redux/configStore";
import useStoreData from "../../../hooks/useStoreData";
import { transformData } from "../../../utils/recursive";
import dayjs from "dayjs";
import ViewGiftExchangeTable from "./ViewGiftExchangeTable";
// import EditUploadGiftExchange from "./EditUploadGiftExchange";
import ButtonWithPermission from "../../../components/ButtonWithPermission/ButtonWithPermission";
import SwitchWithPermission from "../../../components/ButtonWithPermission/SwitchWithPermission";
import InStockGiftExchange from "./InStockGiftExchange";
import BrandedPageLayout from "../../../components/Dashboard/BrandedPageLayout";
import ImportExportMenu from "../../../components/cms/ImportExportMenu";
import RowActions from "../../../components/cms/RowActions";
import StatusTag from "../../../components/cms/StatusTag";
import ListToolbar from "../../../components/cms/ListToolbar";
import CmsTableCard from "../../../components/cms/CmsTableCard";
import { ACTION_ICON, confirmDelete } from "../../../components/cms/actions";
import {
  neutral,
  brand,
  semantic,
  spacing,
  typography,
  radius,
  border,
  shadow,
} from "../../../theme/tokens";

const FILTER_DEFS = [
  { key: "branch", label: "Đơn vị" },
  { key: "category", label: "Loại thưởng" },
  { key: "status", label: "Trạng thái" },
  { key: "date", label: "Thời gian" },
];

// Cột bật/tắt được — `fixed: true` là cột luôn hiện (tên quà + thao tác).
const COLUMN_DEFS = [
  { key: "name", label: "Quà tặng", fixed: true },
  { key: "mcoupon_branch_id", label: "Đơn vị" },
  { key: "type", label: "Loại thưởng" },
  { key: "stock", label: "Hạn lượng" },
  { key: "point", label: "Điểm quy đổi" },
  { key: "unlimited", label: "Không giới hạn lượt đổi" },
  { key: "time_period", label: "Thời gian chương trình" },
  { key: "action", label: "Thao tác", fixed: true },
];

const DEFAULT_VISIBLE_COLUMNS = [
  "mcoupon_branch_id",
  "type",
  "stock",
  "point",
  "unlimited",
  "time_period",
];

const GiftExchangeTable = () => {
  const {
    listGiftExchanges,
    isLoadGiftExchange,
    currentPage,
    pageSize,
    totalRecords,
  } = useSelector((state) => state.persistedReducer.giftExchangeSlice);

  const { data: allListStore, loading: isLoadStoreAll } = useStoreData();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [recordEdit, setRecordEdit] = useState(null);
  const [branchIdSearch, setBranchIdSearch] = useState(null);
  const [optionStatus, setOptionStatus] = useState(null);
  const [giftCategory, setGiftCategory] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);
  const { RangePicker } = DatePicker;
  const { Text } = Typography;
  const [visibleColumns, setVisibleColumns] = useState(DEFAULT_VISIBLE_COLUMNS);

  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  
  const [isModalOpenInStock, setIsModalOpenInStock] = useState(false);

  // Lấy base URL cho mã QR từ biến môi trường
  // const REACT_APP_IMAGE = process.env.REACT_APP_IMAGE || "";

  const handleView = (record) => {
    setSelectedRecord(record);
    setIsViewModalOpen(true);
  };


  const dataTree = transformData(allListStore?.data);
  const options = dataTree?.filter((item) => item.parent_id === 0);
  const handleSearch = (value = null) => {
    setBranchIdSearch(value);
    dispatch(setCurrentPage(1));
  };

  /**
   * Nạp lại danh sách theo ĐÚNG bộ lọc đang áp dụng.
   * Trước đây "Làm mới" và các thao tác xóa/đổi trạng thái gọi
   * `getListGiftExchange({ currentPage, pageSize })` -> mất hết điều kiện lọc,
   * bảng nhảy về danh sách đầy đủ trong khi ô lọc vẫn đang hiển thị.
   */
  const reload = useCallback(
    () =>
      dispatch(
        getListGiftExchange({
          currentPage,
          pageSize,
          mcouponBranchId: branchIdSearch,
          type: giftCategory,
          status: optionStatus,
          selectedDates,
        })
      ),
    [
      dispatch,
      currentPage,
      pageSize,
      branchIdSearch,
      giftCategory,
      optionStatus,
      selectedDates,
    ]
  );

  useEffect(() => {
    reload();
  }, [reload]);

  const handlePageChange = (page) => dispatch(setCurrentPage(page));

  const handleSizeChange = useCallback(
    (_, size) => dispatch(setPageSize(size)),
    [dispatch]
  );

  const handleDelete = async (id) => {
    try {
      const res = await dispatch(deleteGiftExchange(id));
      if (deleteGiftExchange.fulfilled.match(res)) {
        message.success("Xóa chương trình quà tặng thành công!");
        reload();
      } else {
        message.error(
          res.payload?.error || "Không thể xóa chương trình quà tặng."
        );
      }
    } catch (err) {
      console.error("Error deleting gift exchange:", err);
      message.error("Đã xảy ra lỗi khi xóa chương trình.");
    }
  };

  const handleStatusChange = async (record, checked) => {
    try {
      const updatedData = { status: checked ? 1 : 0 };
      const response = await dispatch(
        statusGiftExchange({ id: record.id, data: updatedData })
      );
      if (statusGiftExchange.fulfilled.match(response)) {
        message.success("Cập nhật trạng thái thành công!");
        reload();
      } else {
        message.error("Cập nhật trạng thái thất bại!");
      }
    } catch (err) {
      message.error("Lỗi khi cập nhật trạng thái!");
      console.error("Error updating status:", err);
    }
  };

  const handleStatus = (value) => {
    setOptionStatus(value);
    dispatch(setCurrentPage(1));
  };

  const handleGiftCategory = (value) => {
    setGiftCategory(value);
    dispatch(setCurrentPage(1));
  };

  const handleDateChange = (dates, dateStrings) => {
    setSelectedDates(dateStrings);
    dispatch(setCurrentPage(1));
  };

  /**
   * `ListToolbar` gọi khi ẩn một ô lọc — phải xoá luôn GIÁ TRỊ của nó, không thì
   * điều kiện lọc vẫn còn hiệu lực mà trên màn không còn ô nào hiển thị.
   */
  const clearFilterValue = (key) => {
    if (key === "branch") setBranchIdSearch(null);
    if (key === "category") setGiftCategory(null);
    if (key === "status") setOptionStatus(null);
    if (key === "date") setSelectedDates([]);
    dispatch(setCurrentPage(1));
  };

  const clearAllFilters = () => {
    setBranchIdSearch(null); // Đặt lại ID đơn vị
    setOptionStatus(null); // Đặt lại trạng thái
    setGiftCategory(null); // Đặt lại loại thưởng
    setSelectedDates([]); // Đặt lại ngày
    dispatch(setCurrentPage(1)); // Reset về trang đầu
    // Không gọi lại API ở đây: useEffect đã theo dõi đúng các state trên nên tự
    // fetch lại. Bản cũ dispatch thêm một lần -> hai request cho một thao tác.
  };

  const columns = [
    {
      title: "Quà tặng",
      dataIndex: "name",
      key: "name",
      fixed: 'left',
      width: 200,
      ellipsis: true,
      render: (name, record) => (
        <a 
          style={{
            color: brand.accent,
            fontWeight: 500,
            cursor: 'pointer',
            textDecoration: 'none'
          }}
          onClick={() => handleView(record)}
        >
          {name}
        </a>
      ),
    },
    {
      title: "Đơn vị",
      dataIndex: "mcoupon_branch_id",
      key: "mcoupon_branch_id",
      width: 200,
      ellipsis: true,
      render: (_, record) => (
        <Link 
          to={`/store-manager?search=${encodeURIComponent(record.mcoupon_branch?.name || "")}`} 
          style={{ color: 'inherit', display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          <ShopOutlined style={{ color: neutral[400] }} />
          <Text className="hover:text-cyan-600 transition-colors">
            {record.mcoupon_branch?.name || "Không có dữ liệu"}
          </Text>
        </Link>
      ),
    },
    {
      title: "Loại thưởng",
      dataIndex: "type",
      key: "type",
      align: "center",
      width: 150,
      // Loại quà là PHÂN LOẠI, không phải trạng thái -> tone mặc định.
      render: (type) =>
        type === "PRODUCT" ? (
          <StatusTag>Vật phẩm</StatusTag>
        ) : type === "DATA" ? (
          <StatusTag>Data</StatusTag>
        ) : (
          ""
        ),
    },
    {
      title: "Hạn lượng",
      dataIndex: "stock",
      key: "stock",
      align: "center",
      width: 150,
      // Hết lượt là trạng thái CẦN CHÚ Ý -> chỉ tô màu ở nhánh đó; còn hàng là
      // chuyện bình thường, hiển thị dạng số thuần cho đỡ nhiễu.
      render: (stock) =>
        stock > 0 ? (
          <Text>{Number(stock).toLocaleString("vi-VN")} lượt</Text>
        ) : (
          <StatusTag tone="danger">Hết lượt</StatusTag>
        ),
    },
    {
      title: "Điểm quy đổi",
      dataIndex: "point",
      key: "point",
      align: "center",
      width: 150,
      // Con số thì đừng bọc tag — tag là để báo trạng thái.
      render: (_, record) => (
        <Text strong>{Number(record.point).toLocaleString("vi-VN")}</Text>
      ),
    },
    {
      title: "Không giới hạn lượt đổi",
      dataIndex: "unlimited",
      key: "unlimited",
      align: "center",
      width: 180,
      // Có/Không là thuộc tính cấu hình, không phải tốt/xấu -> không tô màu.
      render: (_, record) => (
        <Text>{record.unlimited === 0 ? "Không" : "Có"}</Text>
      ),
    },
    {
      title: "Thời gian chương trình",
      dataIndex: "time_period",
      key: "time_period",
      width: 400,
      render: (_, record) => {
        const currentDate = new Date();
        const startDate = new Date(record.start_date);
        const endDate = new Date(record.end_date);

        // Kiểm tra trạng thái thời gian
        let status, color, badgeStatus;
        if (currentDate < startDate) {
          status = "Sắp diễn ra";
          color = "#2563EB"; // xanh dương — sắp tới
          badgeStatus = "default";
        } else if (currentDate > endDate) {
          status = "Đã hết hạn";
          color = "#94A3B8"; // xám trung tính — đã kết thúc
          badgeStatus = "default";
        } else {
          status = "Đang diễn ra";
          color = "#16A34A"; // xanh lá — đang chạy
          badgeStatus = "processing";
        }

        // Tính số ngày còn lại
        const timeDiff = endDate - currentDate;
        const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        return (
          <Space direction="vertical" size={2}>
            <Badge
              status={badgeStatus}
              text={<Text style={{ color, fontWeight: 500 }}>{status}</Text>}
            />
            <Text type="secondary" style={{ fontSize: 13 }}>
              {record.start_date} - {record.end_date}
            </Text>
            {daysDiff > 0 && daysDiff <= 7 && (
              <Text style={{ color: semantic.warning, fontSize: 12, fontWeight: 500 }}>
                Còn {daysDiff} ngày hết hạn
              </Text>
            )}
          </Space>
        );
      },
    },
    {
      title: "Thao tác",
      key: "action",
      width: 130,
      fixed: "right",
      render: (_, record) => (
        <Space size={4}>
          {/* Bật/tắt giữ Popconfirm — thao tác đảo lại được ngay, không cần hộp
              thoại chặn màn như xóa. */}
          <Popconfirm
            title="Thay đổi trạng thái"
            description={`Bạn có chắc chắn muốn ${
              record.status === 1 ? "hủy kích hoạt" : "kích hoạt"
            } chương trình này?`}
            onConfirm={() => handleStatusChange(record, record.status === 0 ? 1 : 0)}
            okText="Cập nhật"
            cancelText="Hủy"
            icon={<ExclamationCircleOutlined style={{ color: semantic.warning }} />}
          >
            <Tooltip title={record.status === 1 ? "Đang kích hoạt" : "Đang tắt"}>
              <SwitchWithPermission
                actions={["gift-exchanges.updateStatus"]}
                size="small"
                checked={record.status === 1}
                noPermissionText={"Không có quyền truy cập"}
              />
            </Tooltip>
          </Popconfirm>

          <RowActions
            onView={() => handleView(record)}
            items={[
              {
                key: "edit",
                icon: ACTION_ICON.edit,
                label: "Chỉnh sửa",
                permission: ["gift-exchanges.uploadImage"],
                onClick: () => navigate(`/edit-gift-exchange/${record.id}`),
              },
              {
                key: "in-stock",
                icon: <PlusCircleOutlined />,
                label: "Thêm quà vào kho",
                permission: ["gift-exchanges.uploadImage"],
                onClick: () => {
                  setRecordEdit(record);
                  setIsModalOpenInStock(true);
                },
              },
              {
                key: "delete",
                icon: ACTION_ICON.delete,
                label: "Xóa chương trình",
                danger: true,
                divider: true,
                permission: ["gift-exchanges.delete"],
                onClick: () =>
                  confirmDelete(
                    record.name,
                    () => handleDelete(record.id),
                    "Hành động này không thể hoàn tác."
                  ),
              },
            ]}
          />
        </Space>
      ),
    },
  ];

  const displayColumns = columns.filter(
    (c) => c.fixed || visibleColumns.includes(c.key)
  );


  // Bộ lọc đang áp dụng — dùng chung cho export để file tải về khớp bảng đang xem.
  const exportParams = {
    ...(branchIdSearch ? { mcoupon_branch_id: branchIdSearch } : {}),
    ...(giftCategory ? { type: giftCategory } : {}),
    ...(optionStatus ? { status: optionStatus } : {}),
    ...(selectedDates && selectedDates.length > 0
      ? { start_date: selectedDates[0], end_date: selectedDates[1] }
      : {}),
  };

  return (
    <BrandedPageLayout
      title="Chương trình quà tặng"
      subtitle="Quản lý kho quà tặng, thiết lập điểm quy đổi và theo dõi lịch sử đổi quà của khách hàng."
      breadcrumbItems={[{ title: 'Chương trình', path: '/point-promotion' }, { title: 'Quà tặng' }]}
    >

      <ListToolbar
        filterDefs={FILTER_DEFS}
        filters={{
          branch: (
            <TreeSelect
              style={{ width: '100%' }}
              disabled={isLoadStoreAll}
              placeholder="Đơn vị"
              showSearch
              allowClear
              filterTreeNode={(inputValue, treeNode) =>
                treeNode.title.toLowerCase().includes(inputValue.toLowerCase())
              }
              onChange={handleSearch}
              treeLine
              treeData={options}
              value={branchIdSearch}
            />
          ),
          category: (
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder="Loại thưởng"
              onChange={handleGiftCategory}
              value={giftCategory}
              options={[
                { value: 'PRODUCT', label: 'Vật phẩm' },
                { value: 'DATA', label: 'DATA' },
              ]}
            />
          ),
          status: (
            <Select
              allowClear
              style={{ width: '100%' }}
              placeholder="Trạng thái"
              onChange={handleStatus}
              value={optionStatus}
              options={[
                { value: '1', label: 'Kích hoạt' },
                { value: '0', label: 'Không kích hoạt' },
              ]}
            />
          ),
          date: (
            <RangePicker
              style={{ width: '100%' }}
              placeholder={['Từ ngày', 'Đến ngày']}
              onChange={handleDateChange}
              value={
                selectedDates.length
                  ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
                  : []
              }
            />
          ),
        }}
        onHideFilter={clearFilterValue}
        onClearFilters={clearAllFilters}
        columnDefs={COLUMN_DEFS}
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
        defaultVisibleColumns={DEFAULT_VISIBLE_COLUMNS}
        loading={isLoadGiftExchange}
        onReload={reload}
        actions={
          <>
            <ButtonWithPermission
              actions={['gift-exchanges.store']}
              children={'Thêm mới'}
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={() => navigate('/add-gift-exchange')}
              noPermissionText={'Không có quyền'}
            />
            <ImportExportMenu
              exportUrl="/api/v1/serviceconnect/gift-exchanges/export"
              exportParams={exportParams}
              exportFileName="chuong_trinh_qua_tang.xlsx"
              exportActions={['gift-exchanges.index']}
            />
          </>
        }
      />

      <Form form={form} component={false}>
        <CmsTableCard
          // title="Danh sách chương trình quà tặng"
          // count={isLoadGiftExchange ? 0 : totalRecords}
          columns={displayColumns}
          dataSource={listGiftExchanges || []}
          rowKey="id"
          loading={isLoadGiftExchange}
          pagination={{
            current: currentPage,
            pageSize,
            total: totalRecords,
            showTotal: (total, range) => `${range[0]}–${range[1]} của ${total} quà tặng`,
            onChange: handlePageChange,
            onShowSizeChange: handleSizeChange,
          }}
          locale={{
            emptyText: <Empty description="Chưa có quà tặng nào" style={{ paddingTop: 40 }} />,
          }}
          scroll={{ x: 'max-content' }}
          rowClassName={(record, index) => (index % 2 === 0 ? 'bg-white' : 'bg-gray-50')}
          bordered
        />
      </Form>

      {/*
        Render thường trực (không bọc `isViewModalOpen &&`) để Drawer còn trong cây
        khi đóng và chạy được hoạt ảnh trượt ra. Bọc điều kiện là component bị gỡ
        ngay lúc bấm đóng -> drawer biến mất đột ngột. Nội dung nặng đã có
        `destroyOnClose` lo dọn.
      */}
      <ViewGiftExchangeTable
        isModalOpen={isViewModalOpen}
        handleCancel={() => setIsViewModalOpen(false)}
        record={selectedRecord}
      />

      {isModalOpenInStock && (
        <InStockGiftExchange
          isModalOpen={isModalOpenInStock}
          currentPage={currentPage}
          pageSize={pageSize}
          handleOk={() => setIsModalOpenInStock(false)}
          handleCancel={() => setIsModalOpenInStock(false)}
          record={recordEdit}
        />
      )}

    </BrandedPageLayout>
  );
};

export default GiftExchangeTable;
